import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPlus, FiEdit2, FiTrash2, FiPackage } from 'react-icons/fi';
import api from '@/services/api';
import { formatCurrency } from '@/utils/formatters';
import LoadingSpinner from '@/components/common/LoadingSpinner';

const ProductsList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadProducts(); }, []);

  const loadProducts = async () => {
    try {
      const response = await api.get('/products/my');
      setProducts(response.data);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (productId) => {
    if (!window.confirm('Tem certeza?')) return;
    try {
      await api.delete(`/products/${productId}`);
      loadProducts();
    } catch (error) {
      alert(error.response?.data?.detail || 'Erro');
    }
  };

  const getProductImage = (photos) => {
    if (!photos || photos.length === 0) return null;
    const photo = photos[0];
    // Handle both string URLs and object format {url, public_id}
    if (typeof photo === 'string') return photo;
    if (photo?.url) return photo.url;
    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/lojista')} className="p-2 hover:bg-gray-100 rounded-full"><FiArrowLeft className="text-xl" /></button>
            <h1 className="font-semibold text-gray-800">Meus Produtos</h1>
          </div>
          <button onClick={() => navigate('/lojista/produto/novo')} className="p-2 bg-[#DC143C] text-white rounded-full hover:bg-red-700"><FiPlus /></button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6">
        {loading ? <LoadingSpinner /> : products.length === 0 ? (
          <div className="text-center py-12">
            <FiPackage className="mx-auto text-5xl text-gray-300 mb-4" />
            <p className="text-gray-500 mb-4">Nenhum produto</p>
            <button onClick={() => navigate('/lojista/produto/novo')} className="px-6 py-2 bg-[#DC143C] text-white rounded-lg inline-flex items-center gap-2"><FiPlus /> Adicionar</button>
          </div>
        ) : (
          <div className="space-y-3">
            {products.map((product) => {
              const imageUrl = getProductImage(product.photos);
              return (
                <div key={product.id} className="bg-white rounded-xl p-4 shadow-sm flex gap-4 items-center">
                  {imageUrl ? (
                    <img src={imageUrl} alt={product.name} className="w-20 h-20 object-cover rounded-lg flex-shrink-0" />
                  ) : (
                    <div className="w-20 h-20 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <FiPackage className="text-2xl text-gray-400" />
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-800 truncate">{product.name}</h3>
                    <p className="text-[#DC143C] font-bold">{formatCurrency(product.price)}</p>
                    <span className={`inline-block mt-1 text-xs px-2 py-0.5 rounded-full ${product.stock > 0 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {product.stock > 0 ? `${product.stock} em estoque` : 'Esgotado'}
                    </span>
                  </div>
                  <div className="flex flex-col gap-2 flex-shrink-0">
                    <button onClick={() => navigate(`/lojista/produto/${product.id}`)} className="p-2 text-[#DC143C] hover:bg-red-50 rounded-lg"><FiEdit2 /></button>
                    <button onClick={() => handleDelete(product.id)} className="p-2 text-gray-400 hover:bg-gray-100 hover:text-red-600 rounded-lg"><FiTrash2 /></button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
};

export default ProductsList;
